import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

// Packages
import { reduxForm, Field, FieldArray } from 'redux-form'

// Helpers
import { required, isHudlOrYouTubeURL } from '../../../../../utils/formValidators'

// Form Components
import ReduxFormInput from '../../../../../components/Global/ReduxForms/ReduxFormInput'

class LockerVideosForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    participation: PropTypes.object.isRequired
  }

  render() {
    return(
      <div>
        <form onSubmit={this.props.handleSubmit}>
          <FieldArray
            name="videos"
            component={renderVideos}
          />
          <hr/>
          <button className="cta-gradient" type="submit">
            Save Videos
          </button>
        </form>
      </div>
    )
  }
}

const renderVideos = ({ fields }) => (
  <ul>
    {
      fields.map((video, index) => (
        <li key={index}>
          <Field
            name={video}
            type="text"
            component={ReduxFormInput}
            validate={[required, isHudlOrYouTubeURL]}
            handleInputRemoval={() => fields.remove(index)}
            placeholder="Add YouTube or Hudl Video Link"
          />
        </li>
      ))
    }
    <li>
      <button type="button" className="cta invert" onClick={() => fields.push("")}>
        + Add a Video
      </button>
    </li>
  </ul>
)

// const stripDomain = (value) => {
//   if (value.includes('you')) {
//     // Get YouTube video id:
//     return value.replace(/^https:\/\/youtu.be\//g, "")
//   } else if (value.includes('hudl')) {
//     // Get Hudl video id:
//     if (value.includes('hudl.com/embed/video/')) {
//       let videoId = value.split('hudl.com/embed/video/')[1]
//       return videoId.substring(0, videoId.indexOf("'"))
//     } else if (value.includes('hudl.com/video/')) {
//       return value.split('hudl.com/video/')[1]
//     }
//   }
// }


// Connect to redux-form
LockerVideosForm = reduxForm({
  form: 'LockerVideosForm'
})(LockerVideosForm)


// Connect to redux
const mapStateToProps = (state, ownProps) => {
  const { videos } = ownProps.participation

  return ({
    initialValues: {
      videos: videos.length > 0 ? videos : ['']
    }
  })
}

export default connect(mapStateToProps)(LockerVideosForm)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerVideosForm/LockerVideosForm.js